import { ref, watch } from 'vue';

type ValidationRules = {
  descriptionMinLength?: number;
  descriptionMaxLength?: number;
  titleMinLength?: number;
  titleMaxLength?: number;
};

export function useReviewFormValidation(rules: ValidationRules = {}) {
  const {
    descriptionMinLength = 15,
    descriptionMaxLength = 2000,
    titleMinLength = 1,
    titleMaxLength = 50
  } = rules;

  const ratingDescription = ref('');
  const ratingTitle = ref('');

  const errors = ref({
    description: { min: false, max: false },
    title: { min: false, max: false }
  });

  const dirty = ref({
    description: false,
    title: false
  });

  const hasErrorState = (field: 'description' | 'title') => {
    return (
      !dirty.value[field] &&
      (errors.value[field].min || errors.value[field].max)
    );
  };

  const validate = () => {
    let valid = true;
    errors.value = {
      description: { min: false, max: false },
      title: { min: false, max: false }
    };

    if (ratingDescription.value.length < descriptionMinLength) {
      errors.value.description.min = true;
      valid = false;
    }
    if (ratingDescription.value.length > descriptionMaxLength) {
      errors.value.description.max = true;
      valid = false;
    }

    if (ratingTitle.value.length < titleMinLength) {
      errors.value.title.min = true;
      valid = false;
    }
    if (ratingTitle.value.length > titleMaxLength) {
      errors.value.title.max = true;
      valid = false;
    }

    return valid;
  };

  watch(
    [ratingDescription, ratingTitle],
    ([newDescription, newTitle], [oldDescription, oldTitle]) => {
      dirty.value.description =
        dirty.value.description || newDescription !== oldDescription;
      dirty.value.title = dirty.value.title || newTitle !== oldTitle;
    }
  );

  const resetFormDirtyState = () => {
    dirty.value = { description: false, title: false };
  };

  return {
    hasErrorState,
    validate,
    resetFormDirtyState,
    descriptionMinLength,
    descriptionMaxLength,
    titleMaxLength,
    ratingDescription,
    ratingTitle
  };
}
